import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GermanyFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14626'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14626)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#262626'
				/>
				<g filter='url(#filter0_d_2332_14626)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 9.33329H20V4.66663H0V9.33329Z'
						fill='#F01515'
					/>
				</g>
				<g filter='url(#filter1_d_2332_14626)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V9.33337H0V14Z'
						fill='#FFD521'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14626'
					x='0'
					y='4.66663'
					width='20'
					height='4.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14626'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14626'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_14626'
					x='0'
					y='9.33337'
					width='20'
					height='4.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14626'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14626'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default GermanyFlagIcon;
